import React from 'react';
import '../styles/About.css';

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>About Bricks & Brain</h1>
          <p>Building Tomorrow, Today</p>
        </div>
      </section>

      {/* Our Story Section */}
      <section className="about-content">
        <div className="container">
          <div className="story-section">
            <h2>Our Story</h2>
            <p>
              Founded with a vision to revolutionize the construction industry, <strong>Bricks & Brain</strong> emerged 
              from the collective expertise of seasoned civil engineers, architects, and construction professionals 
              who recognized the need for a company that seamlessly blends traditional building wisdom with 
              contemporary innovation.
            </p>
            <p>
              Our journey began when our founding team identified a critical gap in the market: clients seeking 
              construction partners who not only understand the physical aspects of building—the "Bricks"—but also 
              bring strategic thinking, problem-solving capabilities, and intelligent design solutions—the "Brain"—to 
              every project.
            </p>
          </div>

          {/* Mission & Vision */}
          <div className="mission-vision-grid">
            <div className="mission-card">
              <div className="card-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>
                To deliver exceptional construction and interior design solutions that exceed client expectations 
                through innovation, quality craftsmanship, and unwavering commitment to excellence.
              </p>
            </div>
            <div className="vision-card">
              <div className="card-icon">🔭</div>
              <h3>Our Vision</h3>
              <p>
                To become the most trusted and innovative construction partner in India, recognized for transforming 
                spaces and building lasting relationships with our clients.
              </p>
            </div>
          </div>

          {/* Values Section */}
          <div className="values-section">
            <h2>Our Core Values</h2>
            <div className="values-grid">
              <div className="value-item">
                <div className="value-icon">✨</div>
                <h4>Excellence</h4>
                <p>We strive for perfection in every project, no matter the size</p>
              </div>
              <div className="value-item">
                <div className="value-icon">🤝</div>
                <h4>Integrity</h4>
                <p>Honesty and transparency guide all our business relationships</p>
              </div>
              <div className="value-item">
                <div className="value-icon">🚀</div>
                <h4>Innovation</h4>
                <p>Embracing new technologies and methodologies for better results</p>
              </div>
              <div className="value-item">
                <div className="value-icon">⏱️</div>
                <h4>Reliability</h4>
                <p>Delivering on promises with punctuality and professionalism</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
